export default "__VITE_ASSET__Dh7W0T79__"